import React, { useState, useCallback } from "react";
import StoreForm from "../StoreForm/StoreForm";
import { useThunkDispatch } from "store";
import { uploadFile } from "store/actions";
import { addStore } from "store/store/actions";
import { useHistory } from "react-router-dom";

const StoreAdd: React.FC = () => {
  const thunkDispatch = useThunkDispatch();
  const [image, setImage] = useState<Blob | null>(null);
  const history = useHistory();

  const handleImageSelect = useCallback((file) => {
    if (file.size > 15 * 1024) {
      return "Image size should be less then 15kb";
    }

    setImage(file);
    return null;
  }, []);

  const handleFinish = useCallback(
    async (values) => {
      try {
        let imageUri = null;
        if (image) {
          const imageUpload = await thunkDispatch(
            uploadFile({ path: "images/store", file: image })
          );
          setImage(null);
          imageUri = imageUpload.payload;
        }
        await thunkDispatch(
          addStore({
            ...values,
            ...(imageUri && { imageUrl: imageUri }),
          })
        );
        history.goBack();
      } catch (error) {
        console.log(error);
        // TODO: handle
      }
    },
    [image, thunkDispatch, history]
  );

  return (
    <StoreForm
      title="Add Store"
      subtitle="Creating new store"
      onImageSelect={handleImageSelect}
      onFinish={handleFinish}
      goToUserLocation={true}
      okText="Add"
    />
  );
};

export default StoreAdd;
